import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class MentorBindingTerminatedNotification extends Notification {
  icon() {
    return 'fas fa-user-slash';
  }

  href() {
    const user = app.session.user;
    return user ? app.route('user.taroMentors', { username: user.slug() }) : '#';
  }

  content() {
    const fromUser = this.attrs.notification.fromUser();
    const name = fromUser ? fromUser.displayName() : '对方';
    return name + ' 解除了与你的师徒关系';
  }

  excerpt() {
    const data = this.attrs.notification.content() || {};
    return data.reason || null;
  }
}
